//TODO  When the length of the amount is greater than 6,
//TODO add .toString().slice(0, 6) + "..." to the amount,
//TODO  When the length of the title is greater than 30,
//TODO add .slice(0,30) + "..."
export const DUMMY_DATA = [
  {
    id: "e1",
    title: "New Tv",
    amount: 200.5,
    date: new Date("2020-01-25"),
  },
  {
    id: "e2",
    title: "New desk",
    amount: 400.55,
    date: new Date("2021-11-11"),
  },
  {
    id: "e3",
    title:
      "This is a very long title i added to show how we can slice the title ".slice(
        0,
        30
      ) + "...",
    amount:
      (1890985).toString().slice(0, 6) + "...",
    date: new Date("2022-04-11"),
  },
  {
    id: "e4",
    title: "new laptop",
    amount: 2500,
    date: new Date("2021-05-28"),
  },
  {
    id: "e5",
    title: "airpod pro",
    amount: 500,
    date: new Date("2018-12-10"),
  },
];
